import React from 'react'

import type { SxProps } from '@mui/material'
import { Chip } from '@mui/material'

type BadgeProps = {
  text: string
  className?: string
  color?: 'gray' | 'blue' | 'green' | 'red' | 'yellow'
  sx?: SxProps
}

const COLOR_MAP = {
  gray: 'default',
  blue: 'info',
  green: 'success',
  red: 'error',
  yellow: 'warning',
} as const

// Thin alias over MUI Chip (small, colored) keeping the color-name API call sites use.
const Badge = ({ className, color = 'gray', sx, text }: BadgeProps) => (
  <Chip className={className} color={COLOR_MAP[color]} label={text} size="small" sx={sx} />
)

export default Badge
